import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer';
import { SheetTreeDb } from '../redux/sheetTreeDbSlice';

const useSheetTreeDbsInBook = (bookId: string | null) : [string[], SheetTreeDb[]] => {
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const ids = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].bookId === bookId);
  const sheetTrees = ids.map(id => sheetTreeDb.sheetTrees[id]);

  return [ids, sheetTrees];
}

export default useSheetTreeDbsInBook;
